import { render } from "./RotateArrow.vue?vue&type=template&id=cec88c3e&scoped=true"
import script from "./RotateArrow.vue?vue&type=script&lang=js"
export * from "./RotateArrow.vue?vue&type=script&lang=js"

import "./RotateArrow.vue?vue&type=style&index=0&id=cec88c3e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cec88c3e"]])

export default __exports__